<template>
	<span class="label" :class="[seType]">
		<slot></slot>
		<span class="close" v-if="!!close" @click="handleClose"><span>&times;</span></span>
	</span>
</template>

<script>
	import lib from "../../assets/js/lib.js"
	export default {
		name: 'bsf-label',
		components: {},
		props: {
			type: {
				type: [String, Array],
				default: "default"
			},
			close: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {}
		},
		methods: {
			handleClose(event) {
				this.$emit('close', event);
			}
		},
		mounted: function() {
			this.$nextTick(function() {

			})
		},
		computed: {
			seType() {
				return this.type ? "label-" + this.type : 'label-default'
			}
		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	.label {
		.unbdr;
		padding: 5px 10px;
		position: relative;
		.close {
			float: none;
			position: relative;
			top: 3px;
			opacity:1;
			span{
				color: @cwh;
				text-shadow:none;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// label.vue?6e120a20